import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';

export const useInventoryForecastGradeNoneCount = () => {
  const { data: count, isLoading, isFetching } = useQuery({
    queryKey: ['inventory', 'forecastGradeNoneCount'],
    queryFn: async () => {
      const result = await container.inventoryRepository.getInventory({
        purchasable: true,
        forecastGrades: ['NONE'],
        page: 1,
        limit: 1,
      });
      if (result.status === 'error') throw new Error(result.error.message);
      return result.total;
    },
    refetchOnWindowFocus: false,
  });

  return {
    count,
    isLoading: isLoading || isFetching,
  };
};
